import { useContext } from "react";
import { useDispatch } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { LanguageContext } from "../i18n/LanguageProvider"
import { fetchJobs } from "../services/utils/fetch";

export const useFetchJobs = ({ userId, enabled, callback = () => {} }) => {
  const dispatch = useDispatch();
  const { language } = useContext(LanguageContext);

  return useQuery({
    queryKey: ["jobs", userId, language],
    queryFn: () => fetchJobs(dispatch, callback),
    enabled,
    staleTime: 300_000, // 5 minutes
  });
}
